import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Icon from "../../components/Icon";

export default function FailedEndpointEditor({ path, onRetest, onSkip, onFixWithAI, status, isFixing }) {
    const { t } = useTranslation();
    const [editPath, setEditPath] = useState(path);
    const [editing, setEditing] = useState(false);

    const hint = status === 404 ? t("builder.failed.hint404")
        : status === 401 || status === 403 ? t("builder.failed.hint401")
        : t("builder.failed.hintGeneric");

    return (
        <div className="bg-red-50 border border-red-200 rounded-lg p-4 space-y-3">
            <div className="flex items-start gap-2">
                <Icon name="AlertTriangle" className="w-4 h-4 text-red-500 mt-0.5 shrink-0" />
                <div className="flex-1">
                    <p className="text-sm font-medium text-red-700">{status} {t("common.error")}</p>
                    <p className="text-xs text-red-600 mt-0.5">{hint}</p>
                </div>
            </div>
            {editing ? (
                <div className="space-y-2">
                    <input type="text" value={editPath} onChange={(e) => setEditPath(e.target.value)}
                        className="w-full px-3 py-2 font-mono text-sm border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500" />
                    <div className="flex gap-2 justify-end">
                        <button onClick={() => setEditing(false)} className="px-3 py-1.5 text-xs text-gray-600 hover:bg-gray-200 rounded-md">{t("common.cancel")}</button>
                        <button onClick={() => { setEditing(false); onRetest(editPath); }}
                            className="px-3 py-1.5 text-xs bg-blue-600 text-white rounded-md hover:bg-blue-700 flex items-center gap-1">
                            <Icon name="RefreshCw" className="w-3 h-3" /> {t("builder.failed.retest")}
                        </button>
                    </div>
                </div>
            ) : (
                <div className="flex flex-wrap gap-2">
                    <button onClick={onFixWithAI} disabled={isFixing}
                        className="px-3 py-1.5 text-xs bg-purple-600 text-white rounded-md hover:bg-purple-700 disabled:opacity-50 flex items-center gap-1">
                        {isFixing ? <div className="w-3 h-3 border-2 border-purple-300 border-t-white rounded-full animate-spin" /> : <Icon name="Wand2" className="w-3 h-3" />}
                        {isFixing ? t("builder.failed.aiFixing") : t("builder.failed.fixWithAI")}
                    </button>
                    <button onClick={() => setEditing(true)} className="px-3 py-1.5 text-xs bg-white border text-gray-700 rounded-md hover:bg-gray-50 flex items-center gap-1">
                        <Icon name="Edit3" className="w-3 h-3" /> {t("builder.failed.editPath")}
                    </button>
                    <button onClick={() => onRetest(path)} className="px-3 py-1.5 text-xs bg-white border text-gray-700 rounded-md hover:bg-gray-50 flex items-center gap-1">
                        <Icon name="RefreshCw" className="w-3 h-3" /> {t("builder.failed.retest")}
                    </button>
                    <button onClick={onSkip} className="px-3 py-1.5 text-xs text-gray-500 hover:bg-gray-200 rounded-md">{t("common.skip")}</button>
                </div>
            )}
        </div>
    );
}
